import React from "react";

const HeaderNone = () => {
  return <></>;
};

export default HeaderNone;
